import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { weightLossClinicRoutes } from 'modules/forms/constants/routes.constants';
import FormStep from '../FormStep';
import FormSubmit from '../FormSubmit';

const FormRoutes = (): JSX.Element => {
  return (
    <Switch>
      {weightLossClinicRoutes?.map((route, index) => (
        <Route
          exact
          path={route}
          component={() =>
            index === weightLossClinicRoutes.length - 1 ? (
              <FormSubmit key={route} />
            ) : (
              <FormStep key={route} />
            )
          }
        />
      ))}
      <Redirect to={weightLossClinicRoutes[0]} />
    </Switch>
  );
};

export default FormRoutes;
